export default {
  solutions: [
    {
      link: '/attach/big-box-ecommerce',
      title: 'Big Box ecommerce'
    },
    {
      link: '/attach/direct-to-consumer-brands',
      title: 'Direct to Consumer brands'
    },
    {
      link: '/attach/working-with-influencers',
      title: 'Working with influencers'
    }
  ],
  industries: [
    {
      link: '/attach/apparel-and-footwear',
      title: 'Apparel & Footwear'
    },
    {
      link: '/attach/beauty',
      title: 'Beauty & Personal Care'
    },
    {
      link: '/attach/consumer-electronics',
      title: 'Consumer Electronics'
    },
    {
      link: '/attach/food-and-beverage',
      title: 'Food & Beverage'
    }
  ]
}



// WEBPACK FOOTER //
// ./client/store/imports/SolutionsAndIndustries.js